import { createTheme } from '@mui/material/styles';

// Blood-red palette inspired by Google Material Design 3
const BLOOD_RED = {
  50: '#fce8e8',
  100: '#f7c5c5',
  200: '#f09e9e',
  300: '#e87777',
  400: '#e05858',
  500: '#c62828', // primary
  600: '#b71c1c',
  700: '#9b1515',
  800: '#7f0f0f',
  900: '#5c0808',
};

export const getTheme = (direction: 'ltr' | 'rtl') =>
  createTheme({
    direction,
    palette: {
      mode: 'light',
      primary: {
        main: BLOOD_RED[500],
        light: BLOOD_RED[300],
        dark: BLOOD_RED[700],
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#37474f',
        contrastText: '#ffffff',
      },
      background: {
        default: '#fafafa',
        paper: '#ffffff',
      },
      error: { main: '#d32f2f' },
      success: { main: '#2e7d32' },
    },
    typography: {
      fontFamily: direction === 'rtl' ? '"Cairo", sans-serif' : '"Inter", sans-serif',
      h1: { fontWeight: 900 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      button: { fontWeight: 600, textTransform: 'none' },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            padding: '10px 24px',
            fontSize: '1rem',
          },
          containedPrimary: {
            background: `linear-gradient(135deg, ${BLOOD_RED[500]} 0%, ${BLOOD_RED[700]} 100%)`,
            boxShadow: `0 4px 14px ${BLOOD_RED[200]}`,
            '&:hover': {
              background: `linear-gradient(135deg, ${BLOOD_RED[600]} 0%, ${BLOOD_RED[800]} 100%)`,
              boxShadow: `0 6px 20px ${BLOOD_RED[300]}`,
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            transition: 'box-shadow 0.2s ease, transform 0.2s ease',
            '&:hover': {
              boxShadow: '0 8px 30px rgba(0,0,0,0.14)',
              transform: 'translateY(-2px)',
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: { variant: 'outlined', fullWidth: true },
        styleOverrides: {
          root: { '& .MuiOutlinedInput-root': { borderRadius: 10 } },
        },
      },
      MuiChip: {
        styleOverrides: { root: { borderRadius: 8, fontWeight: 600 } },
      },
    },
  });
